import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Label } from '@ergeon/core-components';
import { getHelpNodePath } from '@ergeon/help-components';

import { WikiNode } from '../types';

import { WIKI_SECTIONS, getSectionCurrentState } from './sections';

const LINK_CLASSES = classNames(
  'flex items-center gap-3 rounded-lg px-2 py-1.5 paragraph-2',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-300',
);

const IDLE_LINK_CLASSES = classNames(
  'text-gray-700 hover:bg-gray-100 hover:text-gray-900',
  'dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white',
);

const CURRENT_LINK_CLASSES = 'bg-blue-50 font-medium text-blue-800 dark:bg-blue-900 dark:text-white';

const getLinkClasses = (isCurrent: boolean) => {
  if (isCurrent) {
    return classNames(LINK_CLASSES, CURRENT_LINK_CLASSES);
  }
  return classNames(LINK_CLASSES, IDLE_LINK_CLASSES);
};

const getIconClasses = (isCurrent: boolean) => {
  if (isCurrent) {
    return 'size-4 shrink-0 text-blue-600 dark:text-blue-300';
  }
  return 'size-4 shrink-0 text-gray-600 dark:text-gray-400';
};

const SectionsNav = ({ node }: { node: WikiNode | null }) => (
  <nav aria-labelledby="wiki-sections-title" className="flex flex-col gap-2">
    <Label className="px-2" id="wiki-sections-title">Sections</Label>
    <ul className="flex flex-col gap-0.5">
      {WIKI_SECTIONS.map(({ icon: Icon, nodeKey, title }) => {
        const currentState = getSectionCurrentState(nodeKey, node);
        const isCurrent = Boolean(currentState);
        return (
          <li key={nodeKey}>
            <Link aria-current={currentState} className={getLinkClasses(isCurrent)} to={getHelpNodePath(nodeKey)}>
              <Icon aria-hidden="true" className={getIconClasses(isCurrent)} />
              <span className="min-w-0 truncate">{title}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  </nav>
);

export default SectionsNav;
